/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_PaymentInputs */

const en_orders_payment = /** @type {(inputs: Orders_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment`)
};

const es_orders_payment = /** @type {(inputs: Orders_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pago`)
};

/**
* | output |
* | --- |
* | "Payment" |
*
* @param {Orders_PaymentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_payment = /** @type {((inputs?: Orders_PaymentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_PaymentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_payment(inputs)
	return es_orders_payment(inputs)
});